var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgSmart = function SvgSmart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5c.69 0 1.25.56 1.25 1.25v1.667a1.25 1.25 0 1 1-2.5 0V8.75c0-.69.56-1.25 1.25-1.25ZM12.5 7.5c.69 0 1.25.56 1.25 1.25v1.667a1.25 1.25 0 1 1-2.5 0V8.75c0-.69.56-1.25 1.25-1.25Z",
    fill: "#fff",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.75a8.25 8.25 0 1 1 0 16.5 8.25 8.25 0 0 1 0-16.5Zm0 1.5a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5Z",
    fill: "#fff",
    fillOpacity: 0.85
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSmart);
export default ForwardRef;